//deptid基本格式
export function formatDeptid() {
  //转换时间格式 created_at
  var date = new Date();
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  var second = date.getMilliseconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  var formatdate = y + m + d + h + second;
  return formatdate;
}
//employeeid基本格式
export function employeeid(deptid) {
  //转换时间格式 created_at
  var date = new Date();
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  var second = date.getMilliseconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  var formatdate = `${deptid}-${second}`;
  return formatdate;
}
//noid基本格式
export function noid() {
  //转换时间格式 created_at
  var date = new Date();
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  var second = date.getMilliseconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  var formatdate = `${+new Date()}${second}`;
  return formatdate;
}

/**
 * dataurl: base64
 * filename: 设置文件名称
 */
export function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime,
  });
}

export function dataURLtoBlob(dataURL) {
  const parts = dataURL.split(";base64,");
  const contentType = parts[0].split(":")[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
}

export function getDate() {
 // 创建一个Date对象，表示当前时间
var currentDate = new Date();

// 获取年份
var year = currentDate.getFullYear();

// 获取月份（注意月份是从0开始计数的，所以需要加1）
var month = currentDate.getMonth() + 1;

// 获取日期
var day = currentDate.getDate();

// 获取星期几（0表示星期日，1表示星期一，以此类推）
var dayOfWeek = currentDate.getDay();

// 获取小时
var hours = currentDate.getHours();

// 获取分钟
var minutes = currentDate.getMinutes();

// 获取秒数
var seconds = currentDate.getSeconds();

// 补零函数
function padZero(value) {
  return value < 10 ? '0' + value : value;
}

// 补零后的日期和时间
var paddedMonth = padZero(month);
var paddedDay = padZero(day);
var paddedHours = padZero(hours);
var paddedMinutes = padZero(minutes);
var paddedSeconds = padZero(seconds);

// 星期几的文本表示
var daysOfWeek = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
var dayOfWeekText = daysOfWeek[dayOfWeek];

  // 打印结果
 
  return {
       Date: year + "-" + paddedMonth + "-" + paddedDay,
       week:dayOfWeekText,
       Time: paddedHours + ":" + paddedMinutes + ":" + paddedSeconds,
  }
}
